// utils
import axios from '../../utils/axios';

const updateUser = async (data, userId) => {
  try {
    const response = await axios({
      method: 'put',
      url: `/users/${userId}`,
      data,
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { updateUser };
